module.exports = __webpack_public_path__ + "static/cover-e545cfe6d2963df98ee232429d036201.png";